export const BULK_ISSUE_REASON_LABEL = {
  UNKNOWN_ERROR: 'Lỗi không xác định',
  NO_EINVOICE: 'Chưa có dữ liệu hóa đơn điện tử',
  ACTION_NOT_ALLOWED: 'Thao tác không được phép',
  ALREADY_ISSUED: 'Đã được phát hành',
  NO_INVOICE_KEY: 'Thiếu khóa hóa đơn điện tử',
  MISSING_EMAIL: 'Thiếu email người nhận',
  MISSING_TAX_CODE: 'Thiếu mã số thuế',
  NOT_SYNCED: 'Chưa đồng bộ dữ liệu',
  INVALID_STATUS: 'Trạng thái không hợp lệ',
}

export function getReasonLabel(reasonCode) {
  if (!reasonCode) return 'Không xác định'
  return BULK_ISSUE_REASON_LABEL[reasonCode] || reasonCode
}

export const BULK_ISSUE_STEP_LABEL = {
  SIGNING: 'Đang ký số',
  SUBMITTING_TAX: 'Đang gửi cơ quan thuế',
  UPDATING_STATUS: 'Đang cập nhật trạng thái',
}

export function getStepLabel(step) {
  if (!step) return ''
  return BULK_ISSUE_STEP_LABEL[step] || step
}

export const BULK_ISSUE_JOB_STATUS = {
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  UNKNOWN: 'UNKNOWN',
}

export function isTerminalJobStatus(status) {
  return (
    status === BULK_ISSUE_JOB_STATUS.COMPLETED ||
    status === BULK_ISSUE_JOB_STATUS.FAILED ||
    status === BULK_ISSUE_JOB_STATUS.UNKNOWN
  )
}
